module.exports = __webpack_public_path__ + "img/img-online-sec-04.png";